module.exports = __webpack_public_path__ + "static/13-90f6bfb1c26a4def9fa298042a7f544f.jpg";